import * as APIRoutes from '@mm/api-routes';
import {
  CreateVoyagerContactsParams,
  VoyagerAttributes,
  VoyagerContacts,
  VoyagerCreateContactsResponse,
  VoyagerKeyType,
  VoyagerLeadsSearchQuery,
  VoyagerLocationsSearch,
  VoyagerRemoteAttributeSearch,
} from '../interfaces/voyagerLeads';
import AuthenticatedController from './AuthenticatedController';

export default class VoyagerController extends AuthenticatedController {
  static async getAllAttributes(args?: {
    isExtended?: boolean;
    withPrefix?: boolean;
  }): Promise<VoyagerAttributes[]> {
    return super.get(APIRoutes.VOYAGER_ATTRIBUTES(args));
  }

  static async searchLeads(
    query: VoyagerLeadsSearchQuery,
    fbPageId: number,
  ): Promise<VoyagerContacts> {
    return super.post(APIRoutes.VOYAGER_SEARCH, {
      ...query,
      facebook_page_id: fbPageId,
    });
  }

  static async retrieveRemoteAttributes(
    attribute: VoyagerKeyType,
    query: string,
  ): Promise<VoyagerRemoteAttributeSearch> {
    return super.get(APIRoutes.VOYAGER_ATTRIBUTE_SEARCH(attribute, query));
  }

  static async retrieveLocationAttributes(
    query: string,
    fbPageId?: number,
  ): Promise<VoyagerLocationsSearch[]> {
    return super.get(APIRoutes.VOYAGER_LOCATIONS_SEARCH(query, fbPageId));
  }

  static async createContacts(
    params: CreateVoyagerContactsParams,
  ): Promise<VoyagerCreateContactsResponse> {
    return super.post(APIRoutes.VOYAGER, { ...params });
  }
}
